export enum EnaioAutoStar {
    none = 0,
    front = 1,
    end = 2,
    both = 3
}
export namespace EnaioAutoStar{
    export function getName(value: EnaioAutoStar): string {
        switch (value) {
            case EnaioAutoStar.none:
                return "none";
            case EnaioAutoStar.front:
                return "front";
            case EnaioAutoStar.end:
                return "end";
            case EnaioAutoStar.both:
                return "both";
        }
    }
}
